import React, { useState } from "react"
import { envAwarePost } from "../../util/util";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button"
import Modal from "react-bootstrap/Modal"
import classes from "./Settings.module.css"

function AccountType({ trainerCode }) {
    const [isClient, setIsClient] = useState(false);
    const [inputTrainerId, setInputTrainerId] = useState("");
    const [errorModalShow, setErrorModalShow] = useState(false);
    const [errorText, setErrorText] = useState("");
    function handleClientConvert(inputTrainerId) {
        if (inputTrainerId === "") {
            setErrorText("To change your account from a Trainer Account to a Client Account, you must first ask your trainer for their ID code and then enter that in the Trainer ID Code box.")
            setErrorModalShow(true);
            return
        } else if (inputTrainerId == trainerCode) {
            setErrorText("You entered your own Trainer ID code for this account. In order for this account to be correctly linked to your Trainer's account, you must enter your trainer's Trainer ID. Ask them for this code and enter it here.")
            setErrorModalShow(true);
            return
        } else if (window.confirm('This cannot be undone. Are you sure you want to convert your account from a Trainer Account to a Client Account?')) {
            envAwarePost("/settingsMobWeb.php",
                {
                    field: "changeToClient",
                    value: "1",
                    trainerIDCode: inputTrainerId,
                }
            ).then((dataObj) => {
                if (dataObj.success == "0") {
                    setErrorText(dataObj.message);
                    setErrorModalShow(true);
                } else {
                    window.location.reload();
                }
            })
        }
    }

    return (
        <>
            <Card className={`${classes.cardWidth} mb-5 shadow px-5`}>
                <Card.Body>
                    <h4>Account Type</h4>
                    <p> If you accidentally registered as a trainer but meant to be a client, you can change that here.</p>
                    <hr class="mt-1" />
                    <Row key="" className="d-flex align-items-center justify-content-center mb-5">
                        <Col >
                            <div className="d-flex align-items-center" style={{ textTransform: "capitalize" }}>
                                Change to a Client Account:
                            </div>
                        </Col>
                        <Col >
                            <Form.Group className="mb-0">
                                <Form.Check onChange={() => setIsClient(prev => !prev)}
                                    checked={isClient} type="checkbox" className="custom-control custom-checkbox" >
                                </Form.Check >
                            </Form.Group>

                        </Col>

                    </Row>
                    {isClient &&
                        <>
                            <Row className="align-items-start justify-content-center mb-1">
                                <Col style={{ textTransform: "capitalize" }}>
                                    Your Trainer's ID Code:
                                </Col>
                                <Col >
                                    <Form.Group  >
                                        <Form.Control type="text" name="trainer_id" value={inputTrainerId} className="align-self-end text-center form-control-alternative"
                                            onChange={(e) => {
                                                setInputTrainerId(e.target.value)
                                            }} />
                                        <Form.Text className="text-muted">
                                            Ask your Trainer for this code.
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Button onClick={() => handleClientConvert(inputTrainerId)} variant="danger" className="">
                                        Change to Client
                                    </Button>
                                </Col>
                            </Row>

                            <Row className="text-danger mb-5"  >
                                Warning: This cannot be undone and should only be done if you accidentally signed up as a trainer.
                            </Row>
                        </>
                    }

                </Card.Body>

            </Card>
            <Modal show={errorModalShow} onHide={() => {setErrorModalShow(false); setErrorText("")} } >
                <Modal.Header closeButton>
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p className="mt-2"> {errorText}</p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={() => {setErrorModalShow(false); setErrorText("")}}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AccountType